<article class="product-card d-flex flex-column h-100 bg-white">
  <div class="product-card__header mb-2">
    <h3 *scText="title()" class="product-card__header--title mt3"></h3>
    @if (showContent()) {
      <div *scText="content()!"></div>
    }
  </div>

  @if (image(); as cardImage) {
    <figure
      class="product-card__image-container w-100 overflow-hidden m-0 mb-2"
    >
      <picture>
        <img *scImage="cardImage" class="w-100 h-100 object-fit-cover" />
      </picture>
    </figure>
  }

  <div class="product-card__content d-flex flex-column flex-grow-1 text-break">
    <ul class="product-card__usp-list">
      @for (usp of uspList(); track $index) {
        <li class="product-card__usp-list-item">
          <crnt-icon
            icon="check"
            class="me-2 product-card__usp-list-item-icon"
          />
          <span *scText="usp"></span>
        </li>
      }
    </ul>
  </div>
  <div class="product-card__footer d-flex flex-column">
    @if (showCost()) {
      <p>
        <span class="product-card__cost"
          >Vanaf €<span *scText="cost()!" class="product-card__cost-text"></span
          >,- </span
        >(excl. BTW)<br />
        <span *scText="costAddition()!"></span>
      </p>
    }
    <crnt-button-alt variant="primary" [fullWidth]="true">
      <a *wlGenericLink="button1()"></a>
    </crnt-button-alt>

    @if (showSecondButton()) {
      <crnt-button-alt variant="tertiary" [fullWidth]="true" class="mt-2">
        <a *wlGenericLink="button2()!"></a>
      </crnt-button-alt>
    }
  </div>
</article>
